/* Shirts Frenzy — product-card colour × view matrix.
   Carousel (‹ › + native swipe) steps through the mockup VIEWS of the current
   colour. Swatch hover recolours the current view; click/tap sticks the colour. */
(function () {
  // Active colour from the collection's colour filter (?filter.v.option.color=…).
  // When present, every card paints itself to that colour on load ("shop by colour").
  function activeFilterColor() {
    try {
      var v = new URLSearchParams(location.search).getAll('filter.v.option.color');
      return v.length ? v[v.length - 1] : null;
    } catch (e) { return null; }
  }

  // ---- regional shipping mode ("Ships from Canada" default for CA shoppers) ----
  // body[data-sf-region] = the shopper's fulfilment region (CA today; EU/UK
  // when those markets open). Preference key: 'sf-region-pref' — 'all' means
  // the shopper opted into browsing US-studio colours; anything else = local.
  // Touch devices synthesize mouseenter/mousemove on the FIRST tap, which our
  // hover-PREVIEW handlers use to repaint the card — and iOS Safari then swallows
  // that same tap's `click`, forcing a second tap to actually commit the colour.
  // Gate every hover-preview handler behind a real hover pointer (matches the CSS
  // `@media (hover:none)` convention); click handlers stay unconditional so a tap
  // commits in one go.
  var CAN_HOVER = !(window.matchMedia && window.matchMedia('(hover: none)').matches);

  var SF_REGION = (document.body && document.body.getAttribute('data-sf-region')) || '';
  function sfLocalMode() {
    try { return !!SF_REGION && localStorage.getItem('sf-region-pref') !== 'all'; }
    catch (e) { return !!SF_REGION; }
  }
  // catalog-level colour→regions map (embedded by theme.liquid) — the
  // colour-level fallback for cards whose product hasn't been redeployed
  // with custom.cross_border yet.
  var SF_RMAP = null;
  function sfRegionMap() {
    if (SF_RMAP === null) {
      SF_RMAP = false;
      var el = document.getElementById('sf-region-colors');
      if (el) { try { SF_RMAP = JSON.parse(el.textContent); } catch (e) {} }
    }
    return SF_RMAP;
  }
  // Colour name → swatch hex, read ONCE from the page-level map (theme.liquid)
  // so cards don't embed a hex per colour. Falls back to a neutral grey.
  var SF_HEX = null;
  function sfHex(name) {
    if (SF_HEX === null) {
      SF_HEX = {};
      var el = document.getElementById('sf-color-hex-map');
      if (el) { try { SF_HEX = JSON.parse(el.textContent) || {}; } catch (e) {} }
    }
    return SF_HEX[(name || '').toLowerCase().trim()] || '#9a9a9d';
  }
  // Card image width: embedded/fetched URLs all carry width=600, but at the
  // rendered card size (~23vw) a standard display only needs 450 (~40% fewer
  // bytes); keep 600 for retina. Phones (≤560px) show ONE full-width card per
  // row, so swapped-in images need the card's real pixel width (capped 1000 —
  // the largest rendition the mockups ship).
  var IMG_W = (function () {
    var dpr = window.devicePixelRatio || 1;
    if (window.innerWidth <= 560) return Math.min(1000, Math.ceil(window.innerWidth * dpr / 100) * 100);
    return dpr >= 1.5 ? 600 : 450;
  })();
  function imgW(u) { return u ? String(u).replace(/([?&])width=\d+/, '$1width=' + IMG_W) : u; }
  // Deferred slides (views 2+) ship with data-src only — the browser would
  // otherwise download every side-by-side slide in the scroll-snap track.
  // Hydrate = promote data-src → src; runs on the first hover/touch/scroll of a
  // card, so images are in flight before a chevron press or swipe lands.
  function hydrateTrack(track) {
    track.querySelectorAll('img[data-src]').forEach(function (img) {
      img.src = imgW(img.getAttribute('data-src'));
      img.removeAttribute('data-src');
    });
  }
  function bindHydrate(media, track) {
    media.addEventListener('pointerenter', function () { hydrateTrack(track); });
    media.addEventListener('touchstart', function () { hydrateTrack(track); }, { passive: true });
    track.addEventListener('scroll', function () { hydrateTrack(track); }, { passive: true });
  }
  // Recolour one <img>: visible (hydrated) slides swap src; deferred slides just
  // get their data-src updated so a swatch hover doesn't download hidden views.
  function setImg(img, u) {
    if (!u) return;
    if (img.hasAttribute('data-src')) { img.setAttribute('data-src', u); }
    else { img.srcset = ''; img.src = u; }
  }

  function bind(media) {
    if (media.dataset.sfCar) return;
    media.dataset.sfCar = '1';
    // Set cards bind exactly like plain cards (the per-card style strip was
    // removed 2026-07-12 for perf — style switching = rail filter + PDP).
    var card = media.closest('.pcard');
    var track = media.querySelector('[data-track]');
    var dataEl = media.querySelector('[data-card-imgs]');
    if (!track) return;

    var imgs = track.querySelectorAll('.pcard-imgel');
    var n = track.querySelectorAll('.pcard-slide').length;
    var swatches = media.querySelectorAll('[data-sw]');

    // colour -> [view urls], in document order
    var matrix = {}, order = [];
    if (dataEl) {
      try {
        JSON.parse(dataEl.textContent).forEach(function (e) {
          if (!e.c) return;
          if (!matrix[e.c]) { matrix[e.c] = []; order.push(e.c); }
          matrix[e.c].push(e.u);
        });
      } catch (err) {}
    }
    var stuck = order[0] || null;
    var fc = activeFilterColor();
    if (fc && matrix[fc]) stuck = fc; // start on the filtered colour, not the default

    // local-shipping mode: drop colours that DON'T fulfil from the shopper's
    // region (per-product custom.cross_border metafield on data-card-xb).
    // Swatches hide, and a hidden default colour repaints to the first
    // local one so the card itself shows a local palette.
    var xbHidden = {}, xbRepaint = false;
    // Cards now show ALL colours (the CA duty distinction lives in the colour
    // filter's two-group split + the PDP "duties may apply" banner). The old
    // per-card region trimming is intentionally disabled.
    if (false) {
      try {
        var xbAll = JSON.parse(media.getAttribute('data-card-xb') || 'null');
        var xbR = xbAll && xbAll[SF_REGION];
        if (!xbR) {
          // no per-product map yet — fall back to the catalog-level map
          var rmap = sfRegionMap();
          if (rmap) {
            xbR = {};
            order.forEach(function (c) {
              if (rmap[c] && rmap[c].indexOf(SF_REGION) === -1) xbR[c] = 'all';
            });
          }
        }
        if (xbR) {
          Object.keys(xbR).forEach(function (c) { if (xbR[c] === 'all') xbHidden[c] = true; });
          // promote the first 6 region-visible colours into the row (ALL
          // colours are in the markup; index > 6 start hidden as .sw-extra)
          var slots = 0;
          swatches.forEach(function (sw) {
            var ok = !xbHidden[sw.getAttribute('data-color')] && slots < 6;
            sw.style.display = ok ? 'inline-block' : 'none';  // inline wins over .sw-extra's display:none
            if (ok) slots++;
          });
          // the card server-renders data-card-color (the featured colour) —
          // matrix order[0] can differ (display-order reordering), so key
          // the hidden-default repaint off what's actually on screen.
          var shown = media.getAttribute('data-card-color') || stuck;
          if (shown && xbHidden[shown] && !(fc && matrix[fc])) {
            for (var oi = 0; oi < order.length; oi++) {
              if (!xbHidden[order[oi]]) { stuck = order[oi]; xbRepaint = true; break; }
            }
          } else if (shown && matrix[shown]) { stuck = shown; }
          // reflect the regional palette in the card chrome: "N colours"
          // meta line + the "+N" swatch-overflow chip
          var visTotal = order.filter(function (c) { return !xbHidden[c]; }).length;
          if (visTotal && visTotal !== order.length) {
            var root = media.closest('.pcard');
            if (root) {
              root.querySelectorAll('.pcard-meta span').forEach(function (el) {
                if (/colours?\s*$/.test(el.textContent)) el.textContent = visTotal + (visTotal === 1 ? ' colour' : ' colours');
              });
            }
            var more = media.querySelector('.sw-more');
            if (more) {
              var shownSw = Array.prototype.filter.call(swatches, function (b) { return b.style.display !== 'none'; }).length;
              var extra = visTotal - shownSw;
              if (extra > 0) { more.textContent = '+' + extra; more.style.display = ''; }
              else more.style.display = 'none';
            }
          }
        }
      } catch (e) {}
    }

    // ---- carousel: walk views of the current colour ----
    var w = function () { return track.clientWidth || 1; };
    var cur = function () { return Math.round(track.scrollLeft / w()); };
    var go = function (i) { track.scrollTo({ left: Math.max(0, Math.min(n - 1, i)) * w(), behavior: 'smooth' }); };
    var prev = media.querySelector('[data-prev]'), next = media.querySelector('[data-next]');
    if (n > 1) {
      if (prev) { prev.hidden = false; prev.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); go(cur() - 1); }); }
      if (next) { next.hidden = false; next.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); go(cur() + 1); }); }
    }

    // ---- hover the mockup → peek a random shot (returns on leave) ----
    // Disabled 2026-06-08 (too much motion); flip ENABLE_HOVER_PEEK to re-enable.
    var ENABLE_HOVER_PEEK = false;
    var link = media.querySelector('.pcard-link');
    if (ENABLE_HOVER_PEEK && link && n > 1) {
      var savedView = 0;
      link.addEventListener('mouseenter', function () {
        savedView = cur();
        // random shot other than the current one, within bounds
        var r = Math.floor(Math.random() * (n - 1));
        if (r >= savedView) r += 1;
        go(r);
      });
      link.addEventListener('mouseleave', function () { go(savedView); });
    }

    // ---- recolour the current view(s), keeping the carousel position ----
    function paint(color) {
      var list = matrix[color];
      if (!list) return;
      imgs.forEach(function (img, i) {
        setImg(img, imgW(list[i] || list[0]));
      });
      swatches.forEach(function (s) { s.classList.toggle('on', s.getAttribute('data-color') === color); });
    }
    bindHydrate(media, track);

    // carry a stuck colour to the PDP via ?color= (the PDP selects it on load)
    var nameLink = card && card.querySelector('.pcard-name');
    function setLinkColor(color) {
      [link, nameLink].forEach(function (a) {
        if (!a) return;
        try { var u = new URL(a.href, location.origin); u.search = ''; u.searchParams.set('color', color); a.href = u.pathname + u.search; }
        catch (e) {}
      });
    }

    swatches.forEach(function (s) {
      var color = s.getAttribute('data-color');
      if (CAN_HOVER) {
        s.addEventListener('mouseenter', function () { paint(color); });
        s.addEventListener('mouseleave', function () { paint(stuck); });
      }
      s.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); stuck = color; paint(color); setLinkColor(color); });
    });

    // colour filter active → repaint this card to the filtered colour on load;
    // otherwise repaint if local-shipping mode moved the default colour
    if (fc && matrix[fc]) paint(fc);
    else if (xbRepaint && stuck) paint(stuck);
  }

  // Colour facet = single-select ("shop by colour") on collection pages: clicking a
  // colour swatch REPLACES any previous colour (other filters/sort preserved) so the
  // whole grid re-themes to one colour; clicking the active colour clears it.
  document.addEventListener('click', function (e) {
    var sw = e.target.closest('[data-sf-color]');
    if (!sw) return;
    e.preventDefault();
    var u = new URL(window.location.href);
    var was = sw.classList.contains('on');
    u.searchParams.delete('filter.v.option.color');
    u.searchParams.delete('page');
    if (!was) u.searchParams.append('filter.v.option.color', sw.getAttribute('data-color'));
    var dest = u.pathname + u.search;
    if (window.sfAjaxNavigate) { window.sfAjaxNavigate(dest); } else { window.location.href = dest; }
  });

  // ---- collection rail: colour facet — zero-count hide + CA two-group split ----
  function facetInit() {
    // zero-count facet swatches are dead clicks (count is variant-intersected
    // server-side) — hide them in every mode. Title attr carries "Colour (n)".
    document.querySelectorAll('.fsw[data-color]').forEach(function (sw) {
      var m = (sw.getAttribute('title') || '').match(/\((\d+)\)\s*$/);
      if (m && m[1] === '0' && !sw.classList.contains('on')) sw.style.display = 'none';
    });
    // CA shoppers: move colours that DON'T fulfil CA→CA into the "from our US
    // studio" group (honest split, not hidden). Everyone else: single group.
    if (!SF_REGION) return;
    var localWrap = document.querySelector('[data-sf-sw-local]');
    var usaWrap = document.querySelector('[data-sf-sw-usa]');
    var usaGroup = document.querySelector('[data-sf-usa-group]');
    if (!localWrap || !usaWrap) return;

    // Primary signal: the shown products' OWN cross_border metafield (embedded
    // per card as data-card-xb). A name-keyed catalog union can't tell "Black on
    // a CA-tee" (local) from "Black on a hoodie" (US-only) — but each product can.
    // For the shopper's region, a colour is 'all' = US-only, sized/absent = local.
    // Aggregate across the cards currently in view (so a Style filter, which
    // narrows to one blank, yields that blank's true split).
    var allSet = {}, localSet = {};
    document.querySelectorAll('[data-card-xb]').forEach(function (c) {
      var xb; try { xb = JSON.parse(c.getAttribute('data-card-xb')); } catch (e) { return; }
      var m = xb && xb[SF_REGION];
      if (!m) return;
      Object.keys(m).forEach(function (col) {
        if (m[col] === 'all') allSet[col] = true; else localSet[col] = true;
      });
    });

    // Fallback only for colours no shown product mentions (e.g. not-yet-redeployed
    // products): the catalog-level colour→regions union (sf-region-colors).
    var rmap = {};
    var mapEl = document.getElementById('sf-region-colors');
    if (mapEl) { try { rmap = JSON.parse(mapEl.textContent) || {}; } catch (e) {} }

    var moved = 0;
    Array.prototype.slice.call(localWrap.querySelectorAll('.fsw[data-color]')).forEach(function (sw) {
      var col = sw.getAttribute('data-color');
      var toUsa;
      if (localSet[col]) toUsa = false;            // some shown product fulfils it locally
      else if (allSet[col]) toUsa = true;          // shown products only cross-border it
      else { var regs = rmap[col]; toUsa = !!(regs && regs.indexOf(SF_REGION) === -1); } // legacy union
      if (toUsa) { usaWrap.appendChild(sw); moved++; }
    });
    if (usaGroup) usaGroup.hidden = moved === 0;
    // hide the local "Colours" group entirely when the split left it with no
    // visible swatches (e.g. a hoodie-only filter — every colour is US-fulfilled)
    var localGroup = localWrap.closest('.fgroup');
    if (localGroup) {
      var localVisible = Array.prototype.filter.call(localWrap.querySelectorAll('.fsw[data-color]'), function (sw) { return sw.style.display !== 'none'; }).length;
      localGroup.hidden = localVisible === 0;
    }
  }

  function init(root) { (root || document).querySelectorAll('.pcard-media').forEach(bind); }
  if (document.readyState !== 'loading') { facetInit(); init(); }
  else document.addEventListener('DOMContentLoaded', function () { facetInit(); init(); });
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  // exposed so the collection AJAX module (sf-collection-ajax.js) can re-bind cards
  // + re-run the colour-facet split after it swaps in a freshly-rendered grid section.
  window.sfCards = { init: init, facetInit: facetInit };
})();
